import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sith': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32L69.7 150.8 10.8 139.2 80.7 230.3A146.7-146.7 0 0 1 80.7 281.7L10.8 372.7 69.7 361.2 0 480 118.8 410.3 107.2 469.1 198.3 399.3C215.3 402.4 232.7 402.4 249.7 399.3L340.8 469.2 329.3 410.3 448 480 378.3 361.2 437.2 372.7 367.3 281.7C370.3 264.7 370.4 247.3 367.3 230.3L437.2 139.2 378.3 150.8 448 32 329.3 101.7 340.8 42.8 249.7 112.7C241.2 111.2 232.6 110.4 224 110.4S206.8 111.2 198.3 112.7L107.2 42.8 118.8 101.7 0 32zM224 131.8C255.8 131.8 287.6 143.9 311.9 168.1 360.4 216.7 360.3 295.4 311.9 343.9S184.7 392.3 136.2 343.8C87.7 295.3 87.7 216.6 136.2 168.1 160.4 143.9 192.2 131.8 224 131.8zM224 168.4C201.6 168.4 179.2 177 162.1 194.1 127.9 228.2 127.9 283.7 162.1 317.9S251.7 352.1 285.9 317.9C320.1 283.7 320.1 228.2 285.9 194.1 268.8 177 246.4 168.4 224 168.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sith.js
// module id = dtwQ
// module chunks = 144